module.exports = __webpack_public_path__ + "img/room702.8b5c6c94.png";